import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'modules/i18n';
import { translation } from './translation';

export function WithdrawalTime() {
  const { keys, t } = useTranslation(translation);

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Typography color="text.secondary">{t(keys.withdrawalTime)}</Typography>
      <Typography fontWeight="500">{t(keys.withdrawalTimeValue)}</Typography>
    </Stack>
  );
}
